import { Button } from "@/Components/ui/button";
import { FolderType } from "@/types/productTypes";
import { Home, ChevronRight } from "lucide-react";
import React from "react";

type BreadcrumbsProps = {
   folders: FolderType[];
   currentFolderId: number | null;
   onNavigate: (folderId: number | null) => void;
};

export default function Breadcrumbs({
   folders,
   currentFolderId,
   onNavigate,
}: BreadcrumbsProps) {
   const getBreadcrumbPath = (folderId: number | null): FolderType[] => {
      const path: FolderType[] = [];
      let current = folders.find((f) => f.id === folderId);

      while (current) {
         path.unshift(current);
         current = folders.find((f) => f.id === current?.parentId);
      }

      return path;
   };

   const breadcrumbs = currentFolderId
      ? getBreadcrumbPath(currentFolderId)
      : [];

   return (
      <div className="flex items-center space-x-2 mb-4">
         <Button
            variant="ghost"
            size="sm"
            onClick={() => onNavigate(null)}
            className="hover:bg-gray-100"
         >
            <Home className="h-4 w-4" />
         </Button>
         {breadcrumbs.map((folder, index) => (
            <React.Fragment key={folder.id}>
               <ChevronRight className="h-4 w-4 text-gray-500" />
               <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onNavigate(folder.id)}
                  className={`hover:bg-gray-100 ${
                     index === breadcrumbs.length - 1 ? "font-bold" : ""
                  }`}
               >
                  {folder.name}
               </Button>
            </React.Fragment>
         ))}
      </div>
   );
}
